// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"GoogleMapWithShimmer_shimmer__NPJWu","map-skeleton":"GoogleMapWithShimmer_map-skeleton__kXNsC"};